import type { SxProps, Theme } from '@mui/material';
import { useDraft } from '../DraftContext';
import type { FieldPath } from '../types';
import { stagedControlSx } from './stagedStyles';

/**
 * The staged outline for a container that already exists, or nothing.
 *
 * For call sites where the control sits in a `Grid item` or `Box` of its own:
 * the container takes the outline and a `StagedWas` sibling takes the value, so
 * the control's own JSX is left alone.
 */
export function useStagedSx(
  paths: readonly FieldPath[]
): SxProps<Theme> | undefined {
  const { stagedFields } = useDraft();
  return stagedFields.at(paths).length > 0 ? stagedControlSx : undefined;
}
